import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SESSION_KEY = "gaina_visit_tracked";

export default function VisitorCounter() {
  const [count, setCount] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    // Re-track whenever the visitor's identity changes so anonymous rows
    // get updated with their real name/email as soon as they log in.
    // Session key is namespaced by user id (or "anon") so a login triggers a
    // fresh track POST that includes the auth cookie.
    (async () => {
      try {
        const key = `${SESSION_KEY}:${user?.id || "anon"}`;
        if (!sessionStorage.getItem(key)) {
          const { data } = await api.post("/visits/track");
          sessionStorage.setItem(key, "1");
          setCount(data.count);
        } else {
          const { data } = await api.get("/visits/count");
          setCount(data.count);
        }
      } catch (e) { /* silent */ }
    })();
  }, [user?.id]);

  if (count === null) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-40 bg-[#09090b] text-white border border-[#facc15] shadow-lg px-3 py-2 flex items-center gap-2 text-xs font-bold tracking-wider group hover:bg-[#ea580c] transition-colors"
      data-testid="visitor-counter"
      title={`Total visitors: ${count.toLocaleString("en-IN")}`}
    >
      <Users className="w-3.5 h-3.5 text-[#facc15] group-hover:text-white transition-colors" />
      <span className="uppercase text-[10px] tracking-[0.15em] opacity-70">Visits</span>
      <span className="font-mono text-sm font-black">{count.toLocaleString("en-IN")}</span>
    </div>
  );
}
